



import {Component, Vue} from 'vue-property-decorator';
import symbolData from './../../../assets/icons/door.svg';
import SvgIcon from './SvgIcon.vue';

@Component({components: {SvgIcon}})
export default class DoorIcon extends Vue {
    protected readonly symbolData = symbolData;
}
